export default __webpack_public_path__ + "static/media/icon_eye.7b4fecbf.svg";